import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Amplify, API } from "aws-amplify";
import { v4 as uuidv4 } from "uuid";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import TravelSnitchScreen from "./components/TravelSnitchScreen.tsx";
import LoginScreen from "./components/LoginScreen.tsx";
import MySnitchesScreen from "./components/MySnitchesScreen.tsx";
import awsmobile from "./aws-exports.ts";
import { updateMVPMetrics } from "./graphql/mutations.ts"; // Import the mutation
import { AuthProvider } from "./contexts/AuthContext.tsx";

Amplify.configure(awsmobile);

const AppNavigator = () => {
  return (
    <Routes>
      <Route path="/" element={<TravelSnitchScreen />} />
      <Route path="/app" element={<TravelSnitchScreen />} />
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/my-snitches" element={<MySnitchesScreen />} />
    </Routes>
  );
};

function App() {
  // Increment the visitor count when the app initializes
  useEffect(() => {
    const incrementUniqueVisitors = async () => {
      try {
        const visitorIdKey = "travelSnitchVisitorId";

        // Check if this visitor already has an ID
        let visitorId = localStorage.getItem(visitorIdKey);
        const isFirstVisit = !visitorId;

        if (isFirstVisit) {
          // First-time visitor
          visitorId = uuidv4();
          localStorage.setItem(visitorIdKey, visitorId);

          // Only increment if it's a new unique visitor
          const result = await API.graphql({
            query: `query GetMVPMetrics {
              getMVPMetrics(mvp_id: "travelsnitch") {
                mvp_id
                visitors
                savings
              }
            }`,
          });
          const metrics = result.data.getMVPMetrics;

          const randomSavings = Math.floor(Math.random() * (150 - 10 + 1)) + 10;

          await API.graphql({
            query: updateMVPMetrics,
            variables: {
              input: {
                mvp_id: "travelsnitch",
                visitors: metrics.visitors + 1,
                savings: metrics.savings + randomSavings,
              },
            },
          });

          console.log("Unique visitor count incremented!");
        } else {
          console.log("Returning visitor — not incrementing count.");
        }
      } catch (error) {
        console.error("Error updating unique visitor count:", error);
      }
    };

    incrementUniqueVisitors();
  }, []);

  return (
    <Router>
      <AuthProvider>
        <AppNavigator />
      </AuthProvider>
    </Router>
  );
}

export default App;
